import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable'

import { IPdfDataObject, PdfElement } from "@src/app/interfaces/pdf.interface";

declare module "jspdf" {
    interface jsPDF {
      lastAutoTable: {
        finalY: number;
      }
    }
}

export class PdfTableElement implements PdfElement {
    public data: IPdfDataObject;
    public readonly newPage: boolean;

    constructor(data: IPdfDataObject, newPage: boolean = false) {
        this.data = data;
        this.newPage = newPage;
    }

    public render(doc: jsPDF, x: number, y: number) {
        autoTable(doc, {
            startY: y,
            margin: { left: x },
            head: this.data.table?.headers,
            body: this.data.table?.data,
            styles: { fontSize: 8 },
            headStyles: { fillColor: '#2d78ff' }
        });

        const finalY = doc.lastAutoTable.finalY;
        const tableHeight = finalY - y;
        return tableHeight;
    }
}
